import React from 'react'
import {Heading} from '@/components/ui/heading'
import {BodyCopy} from '@/components/ui/body-copy'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {useFetchOneEntry} from '@/hooks/useFetchOneEntry'

const fallBackMessage = `Thanks for submitting your email address. We've sent you an email with the information needed to reset your password. The email might take a couple of minutes to reach your account. Please check your junk mail to ensure you receive it.`

const ForgotPasswordSuccess = () => {
    const config = getConfig()

    const {data: passwordResetMessage} = useFetchOneEntry({
        queryKey: ['password-reset-message'],
        options: {
            model: 'password-reset-message',
            apiKey: config.app.builder.api
        }
    })

    return (
        <div className="text-center" data-testid="forgotPasswordSuccess">
            <Heading
                variant="h5"
                className="font-grotesque"
                data-testid="forgotPasswordSuccess-Heading"
            >
                Request to Reset Your Password Received
            </Heading>
            <BodyCopy
                size="small"
                className="mt-4 font-body"
                data-testid="forgotPasswordSuccess-BodyCopy"
            >
                {passwordResetMessage?.data?.message || fallBackMessage}
            </BodyCopy>
        </div>
    )
}

export default ForgotPasswordSuccess
